module.exports = __webpack_public_path__ + "static/img/banner-mobile20.7b11cdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-mobile20.jpg
// module id = m8GW
// module chunks = 1